<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                contactForm: () => import('../forms/ContactForm'),
                fields: [
                    { type: 'autocomplete', text: 'Contact', value: 'contactId', rules: [v => !!v || 'Contact is required'], isRequired: true, form: () => import('./ContactForm'), apiMethod: 'Contacts', claim: 'Contacts' },
                    { type: 'text', text: 'Phone Number', value: 'phoneNumber', rules: [v => !!v || 'Phone Number is required', v => !(v && v.length > 50) || 'Phone Number must be less than 50 characters'], isRequired: true, maxLength: 50 },
                ],
                apiMethod: 'ContactPhones',
                formTitle: 'Contact Phone',
            }
        },
    };
</script>
